/**
 * Модуль для работы с уровнями языка
 */

/**
 * Инициализирует переключение уровней языка
 */
export function initLanguageLevels() {
  const levelButtons = document.querySelectorAll('.language-levels__button')
  const levelPanels = document.querySelectorAll('.language-levels__panel')

  if (!levelButtons.length || !levelPanels.length) return

  levelButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const targetLevel = button.dataset.level

      // Remove active class from all buttons
      levelButtons.forEach((btn) => btn.classList.remove('active'))

      // Add active class to clicked button
      button.classList.add('active')

      // Hide all panels
      levelPanels.forEach((panel) => panel.classList.remove('active'))

      // Show target panel
      const targetPanel = document.querySelector(`.language-levels__panel[data-panel="${targetLevel}"]`)
      if (targetPanel) {
        targetPanel.classList.add('active')

        // Animate progress circle
        animateProgressCircle(targetPanel)
      }
    })
  })

  // Initialize first level
  if (levelButtons[0]) {
    levelButtons[0].click()
  }
}

/**
 * Анимирует круг прогресса
 * @param {HTMLElement} panel - Панель с прогрессом
 */
function animateProgressCircle(panel) {
  const progressCircle = panel.querySelector('.language-levels__progress-circle')
  if (!progressCircle) return

  const progress = parseFloat(progressCircle.dataset.progress) || 0
  const circle = progressCircle.querySelector('.progress-ring__circle')
  if (!circle) return

  const radius = 90
  const circumference = 2 * Math.PI * radius
  const offset = circumference - (progress / 100) * circumference

  // Reset animation
  circle.style.transition = 'none'
  circle.style.strokeDashoffset = circumference

  // Trigger animation
  setTimeout(() => {
    circle.style.transition = 'stroke-dashoffset 1s ease'
    circle.style.strokeDashoffset = offset
  }, 50)
}




